import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(private http: HttpClient) { }

  GetPermissionLevels(): Observable<any> {
    return this.http.get<any>(environment.apiUrl + 'Admin/GetPermissionLevels/');
  }

  GetAllPermissionLevels(): Observable<any> {
    return this.http.get<any>(environment.apiUrl + 'Admin/GetAllPermissionLevels/');
  }

  GetPossiblePermissions(role: any) {

    return this.http.get<any>(environment.apiUrl + 'Admin/GetPossiblePermissions/' + role.Id);
  }

  GetActivePermissions(role: any) {

    return this.http.get<any>(environment.apiUrl + 'Admin/GetActivePermissions/' + role.Id);
  }

  GetRoles() {
    return this.http.get<any>(environment.apiUrl + 'Admin/GetRoles/');
  }

  GetFilteredRoles(institutionTypeName: string, institutionShortName: string) {

    return this.http.get<any>(environment.apiUrl + 'Admin/GetFilteredRoles/' + institutionTypeName + '/' + institutionShortName);
  }

  GetCauses() {
    return this.http.get<any>(environment.apiUrl + 'Institution/GetEntryExitCauses/');
  }

  GetSystemPermissions() {
    return this.http.get<any>(environment.apiUrl + 'Admin/GetSystemPermissions/');
  }

  GetOffices() {

    return this.http.get<any>(environment.apiUrl + 'Admin/GetOffices');
  }

  GetSigns() {

    return this.http.get<any>(environment.apiUrl + 'Admin/GetSigns');
  }

  GetCountriesAsync() {
    return this.http.get<any>(environment.apiUrl + 'Country/GetCountriesAsync');
  }

  UpdateOffice(office) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.put<any>(environment.apiUrl + 'Admin/UpdateOffice', JSON.stringify(office), httpOptions);
  }

  UpdateSystemPermission(data) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.put<any>(environment.apiUrl + 'Admin/UpdateSystemPermission', JSON.stringify(data), httpOptions);
  }


  AddSystemPermissions(data) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.put<any>(environment.apiUrl + 'Admin/AddSystemPermission', JSON.stringify(data), httpOptions);
  }

  removeSystemPermission(data) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.put<any>(environment.apiUrl + 'Admin/RemoveSystemPermission', JSON.stringify(data), httpOptions);
  }

  UpdateSign(sign) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.put<any>(environment.apiUrl + 'Admin/UpdateSign', JSON.stringify(sign), httpOptions);
  }

  UpdateSignType(data) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.put<any>(environment.apiUrl + 'Admin/UpdateSignType', JSON.stringify(data), httpOptions);
  }

  AddSignType(data) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.put<any>(environment.apiUrl + 'Admin/AddSignType', JSON.stringify(data), httpOptions);
  }

  RemoveSignType(data) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.put<any>(environment.apiUrl + 'Admin/RemoveSignType', JSON.stringify(data), httpOptions);
  }

  UpdateCause(cause) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.put<any>(environment.apiUrl + 'Admin/UpdateCause', JSON.stringify(cause), httpOptions);
  }

  UpdateCountry(country) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.put<any>(environment.apiUrl + 'Admin/UpdateCountry', JSON.stringify(country), httpOptions);
  }

  UpdateInstitutionType(institutiontype) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.put<any>(environment.apiUrl + 'Admin/UpdateInstitutionType', JSON.stringify(institutiontype), httpOptions);
  }

  UpdateInstitutionGroup(institutiongroup) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.put<any>(environment.apiUrl + 'Admin/UpdateInstitutionGroup', JSON.stringify(institutiongroup), httpOptions);
  }

  GetOfficeTypes() {

    return this.http.get<any>(environment.apiUrl + 'Admin/GetOfficeTypes');
  }

  GetInstitutionGroups() {

    return this.http.get<any>(environment.apiUrl + 'Institution/GetInstitutionGroupsAsync');
  }

  GetSignTypes() {

    return this.http.get<any>(environment.apiUrl + 'Admin/GetSignTypes');
  }

  GetFirstPageText(isMobile) {
    return this.http.get<any>(environment.apiUrl + 'Admin/GetFirstPageText/' + isMobile);
  }

  EditFirstPageText(input) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    console.log('input: ', input);
    return this.http.put<any>(environment.apiUrl + 'Admin/EditFirstPageText', JSON.stringify(input), httpOptions);
  }

  GetCommittees() {

    return this.http.get<any>(environment.apiUrl + 'Admin/GetCommittees');
  }

  UpdateCommittee(committee) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.put<any>(environment.apiUrl + 'Admin/UpdateCommittee', JSON.stringify(committee), httpOptions);
  }

  GetOfficeCommittees() {

    return this.http.get<any>(environment.apiUrl + 'Admin/GetOfficeCommittees');
  }

  AddOfficeCommittee(officecommittee) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.post<any>(environment.apiUrl + 'Admin/AddOfficeCommittee', JSON.stringify(officecommittee), httpOptions);
  }

  ProcessNonCreatedUsers(missingmembers) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.post<any>(environment.apiUrl + 'Permission/ProcessNonCreatedUsers', missingmembers, httpOptions);
  }

  DeleteMemberPermanently(memberid) {
    return this.http.delete<any>(environment.apiUrl + 'Admin/DeleteMemberPermanently/' + memberid);
  }

  AddCountry(country) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.put<any>(environment.apiUrl + 'Admin/AddCountry', JSON.stringify(country), httpOptions);
  }

  AddElectableSign(electablesign) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.post<any>(environment.apiUrl + 'Admin/AddElectableSign', JSON.stringify(electablesign), httpOptions);
  }

  AddInstitutionType(institutiontype) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.put<any>(environment.apiUrl + 'Admin/AddInstitutionType', JSON.stringify(institutiontype), httpOptions);
  }


  AddInstitutionGroup(institutiongroup) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.put<any>(environment.apiUrl + 'Admin/AddInstitutionGroup', JSON.stringify(institutiongroup), httpOptions);
  }

  AddOffice(office) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.post<any>(environment.apiUrl + 'Admin/AddOffice', JSON.stringify(office), httpOptions);
  }

  AddCause(cause) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }

    return this.http.put<any>(environment.apiUrl + 'Admin/AddCause', JSON.stringify(cause), httpOptions);
  }

  AddCommittee(committee) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Admin/AddCommittee', JSON.stringify(committee), httpOptions);
  }

  AddSign(sign) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.post<any>(environment.apiUrl + 'Admin/AddSign', JSON.stringify(sign), httpOptions);
  }

  GetElectableCommittees() {
    return this.http.get<any>(environment.apiUrl + 'Admin/GetElectableCommittees');
  }

  GetElectableSigns() {
    return this.http.get<any>(environment.apiUrl + 'Admin/GetElectableSigns');
  }

  AddPermission(permissionLevelId: number, permissionId: number) {
    return this.http.get<any>(environment.apiUrl + 'Admin/AddPermission/' + permissionLevelId + '/' + permissionId);
  }

  RemovePermission(permissionLevelId: number, permissionId: number) {
    return this.http.get<any>(environment.apiUrl + 'Admin/RemovePermission/' + permissionLevelId + '/' + permissionId);
  }

  RemoveOfficeCommittee(committee) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }
    return this.http.put<any>(environment.apiUrl + 'Admin/RemoveOfficeCommittee', JSON.stringify(committee), httpOptions);
  }

  AddElectableCommittee(electablecommittee) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Admin/AddElectableCommittee', JSON.stringify(electablecommittee), httpOptions);
  }

  RemoveCause(cause) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }

    return this.http.put<any>(environment.apiUrl + 'Admin/RemoveCause', JSON.stringify(cause), httpOptions);
  }

  RemoveElectableSign(electablesign) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }

    return this.http.put<any>(environment.apiUrl + 'Admin/RemoveElectableSign', JSON.stringify(electablesign), httpOptions);
  }

  RemoveInstitutionType(institutiontype) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }

    return this.http.put<any>(environment.apiUrl + 'Admin/RemoveInstitutionType', JSON.stringify(institutiontype), httpOptions);
  }

  RemoveInstitutionGroup(institutiongroup) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }

    return this.http.put<any>(environment.apiUrl + 'Admin/RemoveInstitutionGroup', JSON.stringify(institutiongroup), httpOptions);
  }

  RemoveCommittee(committee) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }

    return this.http.put<any>(environment.apiUrl + 'Admin/RemoveCommittee', JSON.stringify(committee), httpOptions);
  }

  RemoveElectableCommittee(electablecommittee) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }

    return this.http.put<any>(environment.apiUrl + 'Admin/RemoveElectableCommittee', JSON.stringify(electablecommittee), httpOptions);
  }

  RemoveCountry(country) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }

    return this.http.put<any>(environment.apiUrl + 'Admin/RemoveCountry', JSON.stringify(country), httpOptions);
  }

  RemoveOfficeType(officetype) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }

    return this.http.put<any>(environment.apiUrl + 'Admin/RemoveOfficeType', JSON.stringify(officetype), httpOptions);
  }

  RemoveOffice(office) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }
    return this.http.put<any>(environment.apiUrl + 'Admin/RemoveOffice', JSON.stringify(office), httpOptions);
  }


  RemoveSign(sign) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }

    return this.http.put<any>(environment.apiUrl + 'Admin/RemoveSign', JSON.stringify(sign), httpOptions);
  }


  AddSystemPermissionsToAuthorizationRole(input) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }
    return this.http.post<any>(environment.apiUrl + 'Admin/AddSystemPermissionsToAuthorizationRole', JSON.stringify(input), httpOptions);
  }

  GetLogsFromMemberId(memberId: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }
    return this.http.get<any>(environment.apiUrl + 'Admin/GetLogsFromMemberId/' + memberId);
  }

  getFirstPageText(isMobile: Boolean) {
    return this.http.get<any>(environment.apiUrl + 'Admin/GetFirstPageText/' + isMobile);
  }

  DeleteAndUpdateMemberFee(memberId: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const deleteAndUpdateMemberFeeInputModel = {
      memberId: memberId,
      deleteBeforeInsert: true
    }
    return this.http.post<any>(environment.apiUrl + 'Admin/DeleteAndUpdateMemberFee', JSON.stringify(deleteAndUpdateMemberFeeInputModel), httpOptions);

  }

  DeleteAndUpdateAllMemberFees(institutionId: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const deleteAndUpdateAllMemberFeesInputModel = {
      institutionId: institutionId,
      deleteBeforeInsert: true
    }
    return this.http.post<any>(environment.apiUrl + 'Admin/DeleteAndUpdateAllMemberFees', JSON.stringify(deleteAndUpdateAllMemberFeesInputModel), httpOptions);

  }
}
